import { render, staticRenderFns } from "./BidAcceptOrRejectPopup.vue?vue&type=template&id=b0dd13e8&"
import script from "./BidAcceptOrRejectPopup.vue?vue&type=script&lang=js&"
export * from "./BidAcceptOrRejectPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports